import { Role } from '../types';

export interface PagePermissions {
  view: boolean;
  create: boolean;
  update: boolean;
  delete: boolean;
  export: boolean;
}

export interface PermissionOverride {
  page: string;
  can_view: boolean | null;
  can_create: boolean | null;
  can_update: boolean | null;
  can_delete: boolean | null;
  can_export: boolean | null;
}

export interface RbacPermissionRecord {
  id?: number;
  role: Role;
  page: string;
  can_view: boolean | null;
  can_create: boolean | null;
  can_update: boolean | null;
  can_delete: boolean | null;
  can_export: boolean | null;
  updated_by?: number;
  updated_at?: string;
}

export interface UserPermissionOverride {
  id?: number;
  user_id: number;
  page: string;
  can_view: boolean | null;
  can_create: boolean | null;
  can_update: boolean | null;
  can_delete: boolean | null;
  can_export: boolean | null;
  updated_by?: number;
  updated_at?: string;
}

export interface EffectivePermissions {
  permissions: Record<string, PagePermissions>;
  overrides: {
    role: string[];
    user: string[];
  };
}

export interface RbacPage {
  slug: string;
  label: string;
  group: string;
}

export const RBAC_PAGES: RbacPage[] = [
  { slug: 'integrators', label: 'Dealers', group: 'Organization' },
  { slug: 'customers', label: 'Customers', group: 'Organization' },
  { slug: 'properties', label: 'Properties', group: 'Organization' },
  { slug: 'tenants', label: 'People', group: 'Organization' },

  { slug: 'web-users', label: 'Web Users', group: 'Users & Access' },
  { slug: 'guests', label: 'Guests', group: 'Users & Access' },
  { slug: 'call-history', label: 'Call History', group: 'Users & Access' },

  { slug: 'mobile-users', label: 'Mobile App', group: 'Device Management' },
  { slug: 'intercoms', label: 'Intercoms', group: 'Device Management' },
  { slug: 'cameras', label: 'Cameras', group: 'Device Management' },
  { slug: 'access-control', label: 'Access Control', group: 'Device Management' },
  { slug: 'voice', label: 'Phone Numbers', group: 'Device Management' },
  { slug: 'devices', label: 'Devices', group: 'Device Management' },

  { slug: 'billing', label: 'Billing Center', group: 'Billing & Commerce' },
  { slug: 'accessories', label: 'Accessories Shop', group: 'Billing & Commerce' },

  { slug: 'settings', label: 'Settings', group: 'Account' },
];

export function getPagesByGroup(): { group: string; pages: RbacPage[] }[] {
  const groups: { group: string; pages: RbacPage[] }[] = [];
  let current = '';
  for (const page of RBAC_PAGES) {
    if (page.group !== current) {
      groups.push({ group: page.group, pages: [] });
      current = page.group;
    }
    groups[groups.length - 1].pages.push(page);
  }
  return groups;
}
